import { ErrorDetail } from '../../types';

import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';

import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

interface Props {
  errors: ErrorDetail[];
}

export const ErrorDataGrid = ({ errors }: Props) => {
  const columns = useGetColumnDefs();
  return (
    <TableCRUDLayout
      getRowId={(data) => data.id}
      columns={columns}
      rows={errors}
      editable={false}
      slots={{
        toolbar: CustomToolbar
      }}
    />
  );
};
